// client/src/components/auth/ForgotPassword.js
import React, { useState, useRef, useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import ApiUsers from '../../api/ApiUsers'
import useAutofillSync from '../../hooks/useAutofillSync'

function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  // Ref for autofill detection
  const emailRef = useRef(null)

  // Sync autofilled email to state
  const handleAutofillSync = useCallback((values) => {
    if (values.email) {
      setEmail(values.email)
    }
  }, [])

  // Memoize refs mapping to avoid re-running the effect on each render
  const autofillRefs = useMemo(() => ({ email: emailRef }), [])
  useAutofillSync(autofillRefs, handleAutofillSync)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    setMessage('')

    try {
      const response = await ApiUsers.forgotPassword({ email })
      setMessage(response.message)
    } catch (err) {
      setError(err.message || 'An error occurred. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h2 className="text-center mb-4">Reset Your Password</h2>

              {message && (
                <div
                  className="alert alert-success"
                  data-testid="forgot-password-success"
                >
                  {message}
                </div>
              )}
              {error && (
                <div
                  className="alert alert-danger"
                  data-testid="forgot-password-error"
                >
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    ref={emailRef}
                    type="email"
                    className="form-control"
                    data-testid="forgot-password-email-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    aria-label="email-address"
                    placeholder="Enter your email address"
                  />
                  <div className="form-text text-muted">
                    We'll send you a link to reset your password.
                  </div>
                </div>

                <div className="d-grid">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    data-testid="forgot-password-submit"
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Send Reset Link'}
                  </button>
                </div>
              </form>

              <div className="text-center mt-3">
                <Link to="/sign-in" className="text-decoration-none">
                  Back to Sign In
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
